import { render } from "./MyCouponsIndex.vue?vue&type=template&id=57127ef0"
import script from "./MyCouponsIndex.vue?vue&type=script&lang=js"
export * from "./MyCouponsIndex.vue?vue&type=script&lang=js"
script.render = render

export default script